import { Alert, Box, Button, CircularProgress, Typography } from '@mui/material';
import { verifyMagicToken } from '@servicedesk/ui';
import { useEffect, useState } from 'react';
import { basePath, config } from '../config';

/** Handles /auth/callback?token=… — exchanges the link token for a session. */
export function AuthCallback() {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get('token');
    if (!token) {
      setError('This sign-in link is missing its token.');
      return;
    }
    verifyMagicToken(config.apiBaseUrl, token)
      .then(() => {
        window.location.replace(basePath);
      })
      .catch(() => setError('This sign-in link is invalid or has expired.'));
  }, []);

  if (error) {
    return (
      <Box sx={{ display: 'grid', placeItems: 'center', minHeight: '100vh', gap: 2, p: 2 }}>
        <Alert severity="error">{error}</Alert>
        <Button variant="contained" onClick={() => window.location.replace(basePath)}>
          Back to sign in
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'grid', placeItems: 'center', minHeight: '100vh', gap: 2 }}>
      <CircularProgress />
      <Typography color="text.secondary">Signing you in…</Typography>
    </Box>
  );
}
